/**
 * if text is 'bob' and cutOffPointCharIndex = 1,
 * then result is bo..., if cutOffPointCharIndex >= 2 result is bob,
 * if cutOffPointCharIndex < 0 then result is ...
 */
export default function (text, cutOffPointCharIndex) {
    if (cutOffPointCharIndex < 0) {
        return "...";
    }
    var charAtIndex = text.charAt(cutOffPointCharIndex);
    if (charAtIndex === " ") {
        return text.substring(0, cutOffPointCharIndex) + "...";
    }
    else if (charAtIndex === "") {
        return text;
    }
    else {
        if (cutOffPointCharIndex + 1 >= text.length) {
            return text;
        }
        else {
            return text.substring(0, cutOffPointCharIndex + 1) + "...";
        }
    }
}
